import { getStoreSettings } from './saveStoreSettings';

/** Truthy for API flags sent as 1, "1", or true. Missing values use enabled default for new stores. */
export function isStoreSettingEnabled(value) {
    if (value === 0 || value === '0' || value === false) return false;
    if (value === 1 || value === '1' || value === true) return true;
    return true;
}

export function getProductsShowMethod(storeData, slug) {
    const fromApi = storeData?.products_show_method;
    if (fromApi != null && fromApi !== '') return fromApi;
    return getStoreSettings(slug)?.products_show_method || 'store';
}

/** Bottom nav / catalog tab label aligned with vendor globalSetting options. */
export function getProductNavLabel(method, t, lng) {
    const key = method || 'menu';
    const i18nKey = `globalSetting.${key}`;
    const translated = t(i18nKey, { defaultValue: '' });
    if (translated && translated !== i18nKey) {
        return translated;
    }
    if (lng === 'ar') {
        const labels = {
            menu: 'المنيو',
            store: 'المتجر',
            catalog: 'الكتالوج',
            services: 'الخدمات',
        };
        return labels[key] || labels.catalog;
    }
    return key;
}

export function buildStoreSettingsPayload(homeData) {
    if (!homeData) return null;
    return {
        identity_color: homeData.identity_color,
        lang: homeData.lang,
        products_show_method: homeData.products_show_method,
        default_page: homeData.default_page,
        views_active: homeData.views_active,
        ratings_active: homeData.ratings_active,
    };
}
